import { render } from "./MultiChannel.vue?vue&type=template&id=e549b5dc&scoped=true&ts=true"
import script from "./MultiChannel.vue?vue&type=script&lang=ts"
export * from "./MultiChannel.vue?vue&type=script&lang=ts"

import "./MultiChannel.vue?vue&type=style&index=0&id=e549b5dc&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e549b5dc"]])

export default __exports__